export default function DayoffDetails({data}){
    return (
        <div className="DayoffDetails">
            {
                !data.general && "[Personal] "
            }
            {data.notes}
        </div>
    );
}